export const copyToClipboard = (data, type) => {
    const clipboard = navigator.clipboard;
    if (!clipboard) {
        alert('Clipboard not supported in browser.');
        return;
    }
    clipboard.writeText(data + '').catch(() => { });
};
